"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var ForecastCoordinatorUpdateDTO_1 = require("../model/ForecastCoordinatorUpdateDTO");

var ForecastCoordinatorUpdateDTOConverter_1 = require("./ForecastCoordinatorUpdateDTOConverter");
/**
 * @author OPt
 * @author Adam Drda
 */


var ForecastCoordinatorUpdateDTOConverterImpl =
/*#__PURE__*/
function (_ForecastCoordinatorU) {
  _inherits(ForecastCoordinatorUpdateDTOConverterImpl, _ForecastCoordinatorU);

  function ForecastCoordinatorUpdateDTOConverterImpl() {
    _classCallCheck(this, ForecastCoordinatorUpdateDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastCoordinatorUpdateDTOConverterImpl).apply(this, arguments));
  }

  _createClass(ForecastCoordinatorUpdateDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ForecastCoordinatorUpdateDTO_1.ForecastCoordinatorUpdateDTO(conversions.toClassReferenceId(source.windowItemId), this.valueOrUndefined(source, 'promoVolume', conversions.toBigNumber), this.valueOrUndefined(source, 'lastPromoVolumeUpdate', function (val) {
        return val ? conversions.toDate(val) : null;
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        windowItemId: conversions.toDocumentReferenceId(source.windowItemId)
      });
      this.assignIfDefined(result, source, 'promoVolume', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'lastPromoVolumeUpdate', function (val) {
        return val ? conversions.fromDate(val) : null;
      });
      return result;
    }
  }, {
    key: "assignIfDefined",
    value: function assignIfDefined(obj, source, attribute, fn) {
      if (!utils_1.Utils.isUndefined(source[attribute])) {
        obj[attribute] = source[attribute] === null ? null : fn ? fn(source[attribute]) : source[attribute];
      }
    }
  }, {
    key: "valueOrUndefined",
    value: function valueOrUndefined(source, attribute, conversion) {
      if (utils_1.Utils.isUndefined(source[attribute])) {
        return undefined;
      } else {
        return conversion ? conversion(source[attribute]) : source[attribute];
      }
    }
  }]);

  return ForecastCoordinatorUpdateDTOConverterImpl;
}(ForecastCoordinatorUpdateDTOConverter_1.ForecastCoordinatorUpdateDTOConverter);

exports.ForecastCoordinatorUpdateDTOConverterImpl = ForecastCoordinatorUpdateDTOConverterImpl;